module.exports = __webpack_public_path__ + "img/61.0f6e2839.png";